<template>
    <div style="margin-bottom:15px;margin-top:15px;">
        <textarea :placeholder="placeholder" class="form-control" :name="name"></textarea>
    </div>
</template>

<script>
    export default {
        name: 'comment',
        props: ['placeholder', 'name'],
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>
